import React from "react";
import Select from "../BaseControls/Select";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";

export default function Dropdown(props) {
    const { options, descriptor } = props;
    const config = descriptor.config || {};

    return (
        <ControlTemplate {...props} className="choice-field">
            <Select
                {...props}
                options={options}
                valueKey={config.valueKey || "name"}
                labelKey={config.labelKey || "label"}
                addMissing={true}
            />
        </ControlTemplate>
    );
}

Dropdown.propTypes = controlPropTypes(undefined, true);



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/ChoiceField/dropdown.js